var a=(a,e)=>a.length-1===e;export{a as isLastValue};
//# sourceMappingURL=isLastValue.js.map